// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2tZ8l","label":"SetPasswdForm_label__OdPLV"};